// const ORIGIN = "https://staging.dhi-edu.com";
// export const COLLEGE = "dhi_staging_i3";
// export const URL = ORIGIN + "/dhiapiserver/api";
// export const WEB_SOCKET_PORT = ORIGIN + "/dhiapiserver/pmswebsocket";

 const COLLEGE_ORIGIN='http://localhost:8083';
 const UNIVERSITY_ORIGIN='http://localhost:8085';
 export const COLLEGE='dhi_local' ;
 export const WEB_SOCKET_PORT = COLLEGE_ORIGIN + '/pmswebsocket';

 export function URL(academicType) {
        if(academicType==='UNIVERSITY'){
            return  UNIVERSITY_ORIGIN+'/api';
        }else{
            return  COLLEGE_ORIGIN+'/api';
        }
    }

 
